import { render, staticRenderFns } from "./DispatchIcon.vue?vue&type=template&id=471eb2a8"
import script from "./DispatchIcon.vue?vue&type=script&lang=js"
export * from "./DispatchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports